import { useEffect, useState } from "react";
import { Bell, Check, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApp } from "@/app/AppLayout";
import api from "@/lib/api";

export default function Messages() {
  const { refreshMeta } = useApp();
  const [messages, setMessages] = useState([]);

  const load = () => api.get("/messages").then((r) => setMessages(r.data.messages)).catch(() => {});
  useEffect(() => { load(); }, []);

  const read = async (id) => { await api.post(`/messages/${id}/read`); load(); refreshMeta(); };
  const readAll = async () => { await api.post("/messages/read-all"); load(); refreshMeta(); };

  return (
    <div className="max-w-3xl mx-auto px-6 py-8 animate-fade-up">
      <div className="flex items-center justify-between">
        <div><h1 className="font-serif text-3xl font-bold text-navy">Messages</h1><p className="text-muted2 mt-1">Communications officielles du LARSICOM & Lisungi.</p></div>
        <Button onClick={readAll} variant="outline" className="rounded-full gap-2 border-navy text-navy"><Check className="h-4 w-4" /> Tout marquer lu</Button>
      </div>
      <div className="mt-6 space-y-3">
        {messages.map((m) => (
          <div key={m.id} onClick={() => !m.read && read(m.id)} className={`bg-white rounded-2xl border p-5 cursor-pointer transition-all ${m.read ? "border-[#E5E7EB]" : "border-lisungi-yellow ring-1 ring-lisungi-yellow/40"}`} data-testid={`message-${m.id}`}>
            <div className="flex items-start gap-3">
              <div className="h-9 w-9 rounded-lg bg-navy/5 flex items-center justify-center shrink-0"><Mail className="h-4 w-4 text-navy" /></div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <p className="font-semibold text-navy">{m.title}</p>
                  {!m.read && <span className="h-2 w-2 rounded-full bg-lisungi-yellow" />}
                  <span className="text-[10px] font-mono uppercase bg-navy/5 text-navy px-1.5 py-0.5 rounded ml-auto">{m.category}</span>
                </div>
                <p className="text-sm text-ink mt-1.5 leading-relaxed">{m.content}</p>
                <p className="text-xs text-muted2 mt-2 font-mono">{new Date(m.created_at).toLocaleDateString("fr-FR")}</p>
              </div>
            </div>
          </div>
        ))}
        {messages.length === 0 && <div className="text-center py-16 text-muted2"><Bell className="h-8 w-8 mx-auto mb-3" />Aucun message.</div>}
      </div>
    </div>
  );
}
